import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const getConfigList = async (filters: any = {}) => {
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get('/config' + (queryParams ? '?' + queryParams : ''))
}

export const getConfig = async (id: string) => {
    return await http.get('/config/' + id)
}
